import { addressFromPageKey } from 'common/logic'

export const externalDomainHref = ({ domainKey, review }) => {
  if (review?.meta?.pageKey)
    return addressFromPageKey({
      pageKey: review.meta.pageKey,
      domainKey,
      viaHttp: review.viaHttp,
      viaWww: review.viaWww,
    })

  // TODO: addressFromPageKey should be able to handle blank pageKey to return this...
  return `http${review?.viaHttp ? '' : 's'}://${
    review?.viaWww ? 'www.' : ''
  }${domainKey}/`
}

export const ExternalDomainLink = ({ domainKey, review }) => {
  return (
    <a
      href={externalDomainHref({ domainKey, review })}
      target="_blank"
      rel="nofollow ugc noreferrer"
      className="mx-1 text-gray-500 hover:text-gray-600 text-base"
    >
      [&uarr;]
    </a>
  )
}

export default ExternalDomainLink
